import {EventBus} from "../../../events/EventBus";
import dom, {AddClassEvent, RemoveClassEvent} from "../../../core/dom";
import {WlFavoriteEvent} from "../../../webcomponents/events/WlFavorite";
import {HIDDEN_CLASS} from "../../description/constants";


dom.init();

function handleMarkerState() {
    const FAVORITES_MARKER_SELECTOR = '.js-favorites-marker';
    const FAVORITES_NUMBER_SELECTOR = '.js-favorites-number';

    const eventBus = EventBus.getInstance();
    const wlFavoriteComponentSelector = 'wl-favorite';
    const mobileFavoritesMarker = dom.select(FAVORITES_MARKER_SELECTOR);
    const desktopFavoritesNumber = dom.select(FAVORITES_NUMBER_SELECTOR);

    if (mobileFavoritesMarker) {
        dom.selectAll(wlFavoriteComponentSelector).forEach((item) => {
            item.addEventListener(WlFavoriteEvent.type, (e) => {
                if ((e as WlFavoriteEvent).currentFavorites.listings.size > 0) {
                    eventBus.emit(new RemoveClassEvent({selector: FAVORITES_MARKER_SELECTOR, className: HIDDEN_CLASS}));
                } else {
                    eventBus.emit(new AddClassEvent({selector: FAVORITES_MARKER_SELECTOR, className: HIDDEN_CLASS}));
                }
            });
        });
    }

    if (desktopFavoritesNumber) {
        dom.selectAll(wlFavoriteComponentSelector).forEach((item) => {
            item.addEventListener(WlFavoriteEvent.type, (e) => {
                const numberOfFavorites: number = (e as WlFavoriteEvent).currentFavorites.listings.size;
                desktopFavoritesNumber.textContent = numberOfFavorites > 0 ? numberOfFavorites.toString() : null;
            });
        });
    }
}

export default {
   handleMarkerState
}